const initDirectDebitRadios = () => {
    const directDebitForm = document.querySelector('.direct-debit-form');
    if (!directDebitForm) {
        return;
    }
    const directDebitRadioGroup = document.querySelectorAll('input[name="use_sepa"]');
    const directDebitSepa = document.querySelector('.direct-debit-form .direct-debit-sepa');
    const directDebitBank = document.querySelector('.direct-debit-form .direct-debit-bank-account');
    const handleRadioButtonChange = (event) => {
        const target = event.target;
        const selectedValue = target.value;
        switch (selectedValue) {
            case 'bank':
                directDebitSepa.classList.add('js-hidden');
                directDebitBank.classList.remove('js-hidden');
                if (bankInputs) {
                    bankInputs.forEach((input) => {
                        input.required = true;
                    });
                }
                if (sepaInputs) {
                    sepaInputs.forEach((input) => {
                        input.required = false;
                    });
                }
                break;
            case 'sepa':
            default:
                directDebitSepa.classList.remove('js-hidden');
                directDebitBank.classList.add('js-hidden');
                if (bankInputs) {
                    bankInputs.forEach((input) => {
                        input.required = false;
                    });
                }
                if (sepaInputs) {
                    sepaInputs.forEach((input) => {
                        input.required = true;
                    });
                }
                break;
        }
    };
    directDebitRadioGroup.forEach((radio) => {
        radio.addEventListener('change', handleRadioButtonChange);
    });
    const bankInputs = directDebitBank.querySelectorAll('input');
    const sepaInputs = directDebitSepa.querySelectorAll('input');
    if (bankInputs) {
        bankInputs.forEach((input) => {
            input.required = false;
        });
    }
    if (sepaInputs) {
        sepaInputs.forEach((input) => {
            input.required = true;
        });
    }
};
export const initDirectDebit = () => {
    document.readyState === 'loading'
        ? document.addEventListener('DOMContentLoaded', initDirectDebitRadios)
        : initDirectDebitRadios();
};
